import { __extends } from "tslib";
import { isScheduler } from '../util/isScheduler';
import { isArray } from '../util/isArray';
import { ComplexOuterSubscriber, ComplexInnerSubscriber, innerSubscribe } from '../innerSubscribe';
import { isObject } from '../util/isObject';
import { fromArray } from './fromArray';
import { lift } from '../util/lift';
var NONE = {};
export function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = undefined;
    var scheduler = undefined;
    var keys = undefined;
    if (isScheduler(observables[observables.length - 1])) {
        scheduler = observables.pop();
    }
    if (typeof observables[observables.length - 1] === 'function') {
        resultSelector = observables.pop();
    }
    if (observables.length === 1) {
        var first_1 = observables[0];
        if (isArray(first_1)) {
            observables = first_1;
        }
        if (isObject(first_1) && Object.getPrototypeOf(first_1) === Object.prototype) {
            keys = Object.keys(first_1);
            observables = keys.map(function (key) { return first_1[key]; });
        }
    }
    return lift(fromArray(observables, scheduler), new CombineLatestOperator(resultSelector, keys));
}
var CombineLatestOperator = (function () {
    function CombineLatestOperator(resultSelector, keys) {
        this.resultSelector = resultSelector;
        this.keys = keys;
    }
    CombineLatestOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector, this.keys));
    };
    return CombineLatestOperator;
}());
export { CombineLatestOperator };
var CombineLatestSubscriber = (function (_super) {
    __extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, resultSelector, keys) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.keys = keys;
        _this.active = 0;
        _this.values = [];
        _this.observables = [];
        return _this;
    }
    CombineLatestSubscriber.prototype._next = function (observable) {
        this.values.push(NONE);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            this.active = len;
            this.toRespond = len;
            for (var i = 0; i < len; i++) {
                var observable = observables[i];
                this.add(innerSubscribe(observable, new ComplexInnerSubscriber(this, null, i)));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function () {
        if ((this.active -= 1) === 0) {
            this.destination.complete();
        }
    };
    CombineLatestSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond
            ? 0
            : oldVal === NONE ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.resultSelector) {
                this._tryResultSelector(values);
            }
            else {
                this.destination.next(this.keys ?
                    this.keys.reduce(function (result, key, i) { return (result[key] = values[i], result); }, {}) :
                    values.slice());
            }
        }
    };
    CombineLatestSubscriber.prototype._tryResultSelector = function (values) {
        var result;
        try {
            result = this.resultSelector.apply(this, values);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}(ComplexOuterSubscriber));
export { CombineLatestSubscriber };
//# sourceMappingURL=combineLatest.js.map